import i18n from '../../locales/index'
import ColumnTitle from './column-title.vue'
export default ColumnTitle
